<template>
  <img
    src="@/assets/google.png"
    alt=""
  >
</template>
